import { jsx, jsxs } from "react/jsx-runtime";
import {
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Circle
} from "@tamagui/lucide-icons";
import {
  Button,
  Paragraph,
  Theme,
  Tooltip,
  TooltipGroup,
  XStack,
  YStack
} from "tamagui";
function TooltipDemo() {
  return /* @__PURE__ */ jsx(TooltipGroup, { delay: { open: 3e3, close: 100 }, children: /* @__PURE__ */ jsxs(YStack, { space: "$2", alignSelf: "center", children: [
    /* @__PURE__ */ jsxs(XStack, { space: "$2", children: [
      /* @__PURE__ */ jsx(Demo, { groupId: "0", placement: "top-end", Icon: Circle }),
      /* @__PURE__ */ jsx(Demo, { groupId: "1", placement: "top", Icon: ChevronUp }),
      /* @__PURE__ */ jsx(Demo, { groupId: "2", placement: "top-start", Icon: Circle })
    ] }),
    /* @__PURE__ */ jsxs(XStack, { space: "$2", children: [
      /* @__PURE__ */ jsx(Demo, { groupId: "3", placement: "left", Icon: ChevronLeft }),
      /* @__PURE__ */ jsx(YStack, { flex: 1 }),
      /* @__PURE__ */ jsx(Demo, { groupId: "4", placement: "right", Icon: ChevronRight })
    ] }),
    /* @__PURE__ */ jsxs(XStack, { space: "$2", children: [
      /* @__PURE__ */ jsx(Demo, { groupId: "5", placement: "bottom-end", Icon: Circle }),
      /* @__PURE__ */ jsx(Demo, { groupId: "6", placement: "bottom", Icon: ChevronDown }),
      /* @__PURE__ */ jsx(Demo, { groupId: "7", placement: "bottom-start", Icon: Circle })
    ] })
  ] }) });
}
function Demo({ Icon, ...props }) {
  return /* @__PURE__ */ jsxs(Tooltip, { ...props, children: [
    /* @__PURE__ */ jsx(Tooltip.Trigger, { children: /* @__PURE__ */ jsx(Button, { icon: Icon, circular: true }) }),
    /* @__PURE__ */ jsx(Theme, { inverse: true, children: /* @__PURE__ */ jsxs(
      Tooltip.Content,
      {
        enterStyle: { x: 0, y: -5, opacity: 0, scale: 0.9 },
        exitStyle: { x: 0, y: -5, opacity: 0, scale: 0.9 },
        scale: 1,
        x: 0,
        y: 0,
        opacity: 1,
        animation: [
          "quick",
          {
            opacity: {
              overshootClamping: true
            }
          }
        ],
        children: [
          /* @__PURE__ */ jsx(Tooltip.Arrow, {}),
          /* @__PURE__ */ jsx(Paragraph, { size: "$2", lineHeight: "$1", children: "Hello world" })
        ]
      }
    ) })
  ] });
}
export {
  TooltipDemo
};
//# sourceMappingURL=TooltipDemo.js.map
